module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal"
  }, [_c('v-row', {
    attrs: {
      "justify": "center"
    }
  }, [_c('v-dialog', {
    staticClass: "dialog-width",
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', {
    staticClass: "modal-container",
    attrs: {
      "loading": _vm.load
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "another-content"
  }, [_c('v-btn', {
    staticClass: "modal-button-close-custom",
    attrs: {
      "icon": "",
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.dialog = false
      }
    }
  }, [_c('div', {
    staticClass: "far fa-times-circle",
    staticStyle: {
      "font-size": "34px"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-title"
  }, [_vm._v("Оставить свой отзыв")]), _vm._v(" "), _c('div', {
    staticClass: "modal-input"
  }, [_c('v-text-field', {
    attrs: {
      "label": "Имя"
    },
    model: {
      value: (_vm.firstName),
      callback: function($$v) {
        _vm.firstName = $$v
      },
      expression: "firstName"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "город"
    },
    model: {
      value: (_vm.city),
      callback: function($$v) {
        _vm.city = $$v
      },
      expression: "city"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "отзыв"
    },
    model: {
      value: (_vm.otziv),
      callback: function($$v) {
        _vm.otziv = $$v
      },
      expression: "otziv"
    }
  })], 1), _vm._v(" "), _c('v-rating', {
    attrs: {
      "background-color": "indigo lighten-3",
      "color": "indigo",
      "large": ""
    },
    model: {
      value: (_vm.rating),
      callback: function($$v) {
        _vm.rating = $$v
      },
      expression: "rating"
    }
  }), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "modal-button-send",
    on: {
      "click": function($event) {
        return _vm.newLid('Новый отзыв')
      }
    }
  }, [_vm._v("отправить")])], 1)], 1)])])], 1), _vm._v(" "), _c('v-dialog', {
    staticClass: "dialog-width",
    model: {
      value: (_vm.dialogСall),
      callback: function($$v) {
        _vm.dialogСall = $$v
      },
      expression: "dialogСall"
    }
  }, [_c('v-card', {
    staticClass: "modal-container",
    attrs: {
      "loading": _vm.load
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "another-content"
  }, [_c('v-btn', {
    staticClass: "modal-button-close-custom",
    attrs: {
      "icon": "",
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.dialogСall = false
      }
    }
  }, [_c('div', {
    staticClass: "far fa-times-circle",
    staticStyle: {
      "font-size": "34px"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-title"
  }, [_vm._v("вызвать нарколога")]), _vm._v(" "), _c('div', {
    staticClass: "modal-input"
  }, [_c('v-text-field', {
    attrs: {
      "label": "Имя"
    },
    model: {
      value: (_vm.firstName),
      callback: function($$v) {
        _vm.firstName = $$v
      },
      expression: "firstName"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "номер телефона"
    },
    model: {
      value: (_vm.tel),
      callback: function($$v) {
        _vm.tel = $$v
      },
      expression: "tel"
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "modal-button-send",
    on: {
      "click": function($event) {
        return _vm.newLid('Вызов нарколога')
      }
    }
  }, [_vm._v("отправить")])], 1)], 1)])])], 1), _vm._v(" "), _c('v-dialog', {
    staticClass: "dialog-width",
    model: {
      value: (_vm.dialogMap),
      callback: function($$v) {
        _vm.dialogMap = $$v
      },
      expression: "dialogMap"
    }
  }, [_c('v-card', {
    staticClass: "modal-container"
  }, [_c('div', {
    staticClass: "modal-content-map"
  }, [_c('div', {
    staticClass: "another-content"
  }, [_c('v-btn', {
    staticClass: "modal-button-close-custom",
    attrs: {
      "icon": "",
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.dialogMap = false
      }
    }
  }, [_c('div', {
    staticClass: "far fa-times-circle",
    staticStyle: {
      "font-size": "34px"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-title-map"
  }, [_vm._v("Наше местоположение")]), _vm._v(" "), _c('div', {
    staticClass: "google__map"
  }, [_c('iframe', {
    staticClass: "map",
    staticStyle: {
      "border": "0"
    },
    attrs: {
      "src": "https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d30651.10180568296!2d39.70349703512452!3d47.232228922470384!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sru!2sru!4v1603526436345!5m2!1sru!2sru",
      "width": "100%",
      "height": "421px",
      "frameborder": "0",
      "allowfullscreen": "",
      "aria-hidden": "false",
      "tabindex": "0"
    }
  })])], 1)])])], 1), _vm._v(" "), _c('v-dialog', {
    staticClass: "dialog-width",
    model: {
      value: (_vm.dialogСallCons),
      callback: function($$v) {
        _vm.dialogСallCons = $$v
      },
      expression: "dialogСallCons"
    }
  }, [_c('v-card', {
    staticClass: "modal-container",
    attrs: {
      "loading": _vm.load
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "another-content"
  }, [_c('v-btn', {
    staticClass: "modal-button-close-custom",
    attrs: {
      "icon": "",
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.dialogСallCons = false
      }
    }
  }, [_c('div', {
    staticClass: "far fa-times-circle",
    staticStyle: {
      "font-size": "34px"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-title"
  }, [_vm._v("получить консультацию")]), _vm._v(" "), _c('div', {
    staticClass: "modal-input"
  }, [_c('v-text-field', {
    attrs: {
      "label": "Имя"
    },
    model: {
      value: (_vm.firstName),
      callback: function($$v) {
        _vm.firstName = $$v
      },
      expression: "firstName"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "номер телефона"
    },
    model: {
      value: (_vm.tel),
      callback: function($$v) {
        _vm.tel = $$v
      },
      expression: "tel"
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "modal-button-send",
    on: {
      "click": function($event) {
        return _vm.newLid('Консультация')
      }
    }
  }, [_vm._v("отправить")])], 1)], 1)])])], 1), _vm._v(" "), _c('v-dialog', {
    staticClass: "dialog-width",
    model: {
      value: (_vm.dialogСallDoctor),
      callback: function($$v) {
        _vm.dialogСallDoctor = $$v
      },
      expression: "dialogСallDoctor"
    }
  }, [_c('v-card', {
    staticClass: "modal-container",
    attrs: {
      "loading": _vm.load
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "another-content"
  }, [_c('v-btn', {
    staticClass: "modal-button-close-custom",
    attrs: {
      "icon": "",
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.dialogСallDoctor = false
      }
    }
  }, [_c('div', {
    staticClass: "far fa-times-circle",
    staticStyle: {
      "font-size": "34px"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-title"
  }, [_vm._v("записаться на прием ")]), _vm._v(" "), _c('div', {
    staticClass: "modal-input"
  }, [_c('v-text-field', {
    attrs: {
      "label": "Имя"
    },
    model: {
      value: (_vm.firstName),
      callback: function($$v) {
        _vm.firstName = $$v
      },
      expression: "firstName"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "номер телефона"
    },
    model: {
      value: (_vm.tel),
      callback: function($$v) {
        _vm.tel = $$v
      },
      expression: "tel"
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "modal-button-send",
    on: {
      "click": function($event) {
        return _vm.newLid('Запись на прием')
      }
    }
  }, [_vm._v("отправить")])], 1)], 1)])])], 1), _vm._v(" "), _c('v-dialog', {
    staticClass: "dialog-width",
    model: {
      value: (_vm.dialogOnPrice),
      callback: function($$v) {
        _vm.dialogOnPrice = $$v
      },
      expression: "dialogOnPrice"
    }
  }, [_c('v-card', {
    staticClass: "modal-container",
    attrs: {
      "loading": _vm.load
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "another-content"
  }, [_c('v-btn', {
    staticClass: "modal-button-close-custom",
    attrs: {
      "icon": "",
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.dialogOnPrice = false
      }
    }
  }, [_c('div', {
    staticClass: "far fa-times-circle",
    staticStyle: {
      "font-size": "34px"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-title"
  }, [_vm._v("записаться на услугу ")]), _vm._v(" "), _c('div', {
    staticClass: "modal-input"
  }, [_c('v-text-field', {
    attrs: {
      "label": "Имя"
    },
    model: {
      value: (_vm.firstName),
      callback: function($$v) {
        _vm.firstName = $$v
      },
      expression: "firstName"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "номер телефона"
    },
    model: {
      value: (_vm.tel),
      callback: function($$v) {
        _vm.tel = $$v
      },
      expression: "tel"
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "modal-button-send",
    on: {
      "click": function($event) {
        return _vm.newLid('Получение услуг')
      }
    }
  }, [_vm._v("отправить")])], 1)], 1)])])], 1), _vm._v(" "), _c('v-dialog', {
    staticStyle: {
      "width": "90% !important"
    },
    model: {
      value: (_vm.dialogEdit),
      callback: function($$v) {
        _vm.dialogEdit = $$v
      },
      expression: "dialogEdit"
    }
  }, [_c('v-card', {
    staticClass: "modal-container",
    attrs: {
      "loading": _vm.load
    }
  }, [_c('div', {
    staticClass: "modal-content-edit"
  }, [_c('div', {
    staticClass: "another-content"
  }, [_c('v-btn', {
    staticClass: "modal-button-close-custom",
    attrs: {
      "icon": "",
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.dialogEdit = false
      }
    }
  }, [_c('div', {
    staticClass: "far fa-times-circle",
    staticStyle: {
      "font-size": "34px"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-title"
  }, [_vm._v(" Редактировать блок " + _vm._s(_vm.editName) + " ")]), _vm._v(" "), _c('v-textarea', {
    attrs: {
      "solo": "",
      "name": "input-7-4"
    },
    model: {
      value: (_vm.editText),
      callback: function($$v) {
        _vm.editText = $$v
      },
      expression: "editText"
    }
  }), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "modal-button-send",
    on: {
      "click": function($event) {
        return _vm.saveBlock()
      }
    }
  }, [_vm._v("Сохранить")])], 1)], 1)])])], 1), _vm._v(" "), _c('v-dialog', {
    staticStyle: {
      "width": "90% !important"
    },
    model: {
      value: (_vm.dialogDescription),
      callback: function($$v) {
        _vm.dialogDescription = $$v
      },
      expression: "dialogDescription"
    }
  }, [_c('v-card', {
    staticClass: "modal-container",
    attrs: {
      "loading": _vm.load
    }
  }, [_c('div', {
    staticClass: "modal-content-edit"
  }, [_c('div', {
    staticClass: "another-content"
  }, [_c('v-btn', {
    staticClass: "modal-button-close-custom",
    attrs: {
      "icon": "",
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.dialogDescription = false
      }
    }
  }, [_c('div', {
    staticClass: "far fa-times-circle",
    staticStyle: {
      "font-size": "34px"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-title"
  }, [_vm._v(" Настройки страницы ")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "title"
    },
    model: {
      value: (_vm.title),
      callback: function($$v) {
        _vm.title = $$v
      },
      expression: "title"
    }
  }), _vm._v(" "), _c('v-textarea', {
    attrs: {
      "solo": "",
      "name": "input-7-4",
      "label": "description"
    },
    model: {
      value: (_vm.description),
      callback: function($$v) {
        _vm.description = $$v
      },
      expression: "description"
    }
  }), _vm._v(" "), _c('v-textarea', {
    attrs: {
      "solo": "",
      "name": "input-7-4",
      "label": "keywords"
    },
    model: {
      value: (_vm.keywords),
      callback: function($$v) {
        _vm.keywords = $$v
      },
      expression: "keywords"
    }
  }), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "modal-button-send",
    on: {
      "click": function($event) {
        return _vm.saveConfig()
      }
    }
  }, [_vm._v("Сохранить")])], 1)], 1)])])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8fd34b58","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modal.vue
// module id = 135
// module chunks = 2